module.exports = __webpack_public_path__ + "img/shape-7.beaa8dd5.png";